import React from 'react'
import PropTypes from 'prop-types'

import { setIframeColor, setIframeSize } from './configs'
import prevIcon from '../../icons/prevWhite.png'
import classes from './styles.module.scss'
import classNames from 'classnames'

const Iframe = ({ device, src, close, color, isFullScreenWidget }) => (
  <>
    <div
      onClick={close}
      className={classNames(classes.closeIframeBtnWrapper, 'close-iframe')}
      style={setIframeColor(color)}>
      <div className={classes.closeIframeBtn} style={setIframeColor(color)}>
        <img width="10px" height="15px" src={prevIcon} alt="close iframe" />
      </div>
    </div>
    <iframe
      src={src}
      name={`${src}_iframe`}
      title={`${src}_iframe`}
      className={classes.iframe}
      style={setIframeSize(device.width, device.height, isFullScreenWidget)}>
      <p>Your browser does not support iframes.</p>
    </iframe>
  </>
)

Iframe.propTypes = {
  color: PropTypes.string,
  src: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isFullScreenWidget: PropTypes.bool.isRequired,
  device: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default Iframe
